module.exports = __webpack_public_path__ + "img/police.3e5bde66.svg";